import { ILogistics } from "@nkr/models/index";
import { Glyphicon } from "react-bootstrap";
import { TableWrapper, TableHeadWrapper, TableBodyWrapper } from "../../../styles";

interface IProps {
    data: ILogistics,
    fontSize: number
}

const LogisticsViewContent = ({ data, fontSize }: IProps) => {
    if (data == null)
        return null;

    const {
        position, chainId, clusterNumber, donorCenter, donorAlias,
        rdnCenterId, rdnCenterAlias,
        recipientCenter, recipientAlias,
        earliestPickupTime: earliestPickup, latestDropoffTime: latestDropoff,
        donorSurgeon, recipientSurgeon,
        logisticsProviderName: logisticsProvider, jobNumber
    } = data;

    const swapNumber = chainId + "/" + clusterNumber + "/" + position;

    const renderDate = (date: string, timezone: string) => {
        if (date) {
            return <>{date}&nbsp;{timezone}</>
        } else {
            return null;
        }
    };

    return (
        <>
            <div className="row alert alert-info" style={{ padding: 7, marginBottom: 10, display: "flex", justifyContent: "space-around" }}>
                <div className="text-center">
                    <span style={{ fontWeight: 700 }}>Swap #</span><br />
                    <span>{swapNumber}</span>
                </div>

                <div style={{ display: 'flex', alignItems: "center" }}>
                    <div className="text-center">
                        <span style={{ fontWeight: 700 }}>{donorCenter}</span>
                        {rdnCenterId > 0 ?
                            <span style={{ paddingLeft: 5 }}>(<span style={{ color: "red" }}>{rdnCenterAlias}</span>)</span>
                            : null}
                        <br />
                        <span>{donorAlias}</span>
                    </div>

                    <div className="text-center" style={{ width: 50 }}>
                        <Glyphicon glyph="forward" />
                    </div>

                    <div className="text-center">
                        <span style={{ fontWeight: 700 }}>{recipientCenter}</span><br />
                        <span>{recipientAlias}</span>
                    </div>
                </div>

                <div className="text-center">
                    <span style={{ fontWeight: 700 }}>Earliest Pickup</span><br />
                    <span>{earliestPickup}</span>
                </div>
                <div className="text-center">
                    <span style={{ fontWeight: 700 }}>Latest Dropoff</span><br />
                    <span>{latestDropoff}</span>
                </div>
            </div>

            <div className="row alert alert-warning" style={{ padding: 7, marginBottom: 10, display: "flex", justifyContent: "space-between" }}>
                <div className="text-center">
                    <span style={{ fontWeight: 700 }}>Logistics Provider</span><br />
                    {logisticsProvider}
                </div>
                <div className="text-center">
                    <span style={{ fontWeight: 700 }}>Job #</span><br />
                    {jobNumber ? jobNumber : '--'}
                </div>
                <div className="text-center">
                    <span style={{ fontWeight: 700 }}>Donor Surgeon</span><br />
                    {donorSurgeon ? donorSurgeon.fullName : '--'}
                </div>
                <div className="text-center">
                    <span style={{ fontWeight: 700 }}>Recipient Surgeon</span><br />
                    {recipientSurgeon ? recipientSurgeon.fullName : '--'}
                </div>
            </div>

            <div>
                <TableWrapper className="table-striped table-condensed" fontSize={fontSize}>
                    <TableHeadWrapper fontSize={fontSize}>
                        <tr>
                            <th></th>
                            <th className='text-center' style={{ width: "23.5%" }}>Primary</th>
                            <th className='text-center' style={{ width: "23.5%" }}>Backup</th>
                            <th className='text-center' style={{ width: "23.5%" }}>Actual</th>
                        </tr>
                    </TableHeadWrapper>
                    <TableBodyWrapper fontSize={fontSize}>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>Donor Surgery/Pickup Date/Time</td>
                            <td className='text-center'>
                                {data.kidneyPickupDateTime}&nbsp;{data.kidneyPickupDateTimeTz}
                            </td>
                            <td className='text-center'>
                                {renderDate(data.kidneyPickupDateTimeBackup, data.kidneyPickupDateTimeTz)}
                            </td>
                            <td className='text-center'>
                                {renderDate(data.kidneyPickupDateTimeActual, data.kidneyPickupDateTimeTz)}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>PU Ground Miles</td>
                            <td className='text-center'>
                                {data.pickupGroundMiles}
                            </td>
                            <td className='text-center'>
                                {data.pickupGroundMilesBackup}
                            </td>
                            <td className='text-center'>
                                {data.pickupGroundMilesActual}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>Flight Route or Ground</td>
                            <td className='text-center'>
                                {data.flightRouteOrGround}
                            </td>
                            <td className='text-center'>
                                {data.flightRouteOrGroundBackup}
                            </td>
                            <td className='text-center'>
                                {data.flightRouteOrGroundActual}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>Transport Method</td>
                            <td className='text-center'>
                                {data.transportMethodDescription}
                            </td>
                            <td className='text-center'>
                                {data.transportMethodBackupDescription}
                            </td>
                            <td className='text-center'>
                                {data.transportMethodActualDescription}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>Transportation Cost</td>
                            <td className='text-center'>
                                {data.transportCost}
                            </td>
                            <td className='text-center'>
                                {data.transportCostBackup}
                            </td>
                            <td className='text-center'>
                                {data.transportCostActual}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>Flight Carrier &amp; Number</td>
                            <td className='text-center'>
                                {data.flightCarrierAndNumber}
                            </td>
                            <td className='text-center'>
                                {data.flightCarrierAndNumberBackup}
                            </td>
                            <td className='text-center'>
                                {data.flightCarrierAndNumberActual}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>Tendered to Airline Date/Time</td>
                            <td></td>
                            <td></td>
                            <td className='text-center'>
                                {renderDate(data.tenderedToAirlineActual, data.tenderedToAirlineActualTz)}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>Leg 1 Departure Date/Time</td>
                            <td className='text-center'>
                                {renderDate(data.flightDepartureTime, data.flightDepartureTimeTz)}
                            </td>
                            <td className='text-center'>
                                {renderDate(data.flightDepartureTimeBackup, data.flightDepartureTimeBackupTz)}
                            </td>
                            <td className='text-center'>
                                {renderDate(data.flightDepartureTimeActual, data.flightDepartureTimeActualTz)}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>Leg 1 Arrival Date/Time</td>
                            <td className='text-center'>
                                {renderDate(data.flightArrivalTime, data.flightArrivalTimeTz)}
                            </td>
                            <td className='text-center'>
                                {renderDate(data.flightArrivalTimeBackup, data.flightArrivalTimeBackupTz)}
                            </td>
                            <td className='text-center'>
                                {renderDate(data.flightArrivalTimeActual, data.flightArrivalTimeActualTz)}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>Leg 2 Departure Date/Time</td>
                            <td className='text-center'>
                                {renderDate(data.leg2DepartureTime, data.leg2DepartureTimeTz)}
                            </td>
                            <td className='text-center'>
                                {renderDate(data.leg2DepartureTimeBackup, data.leg2DepartureTimeBackupTz)}
                            </td>
                            <td className='text-center'>
                                {renderDate(data.leg2DepartureTimeActual, data.leg2DepartureTimeActualTz)}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>Leg 2 Arrival Date/Time</td>
                            <td className='text-center'>
                                {renderDate(data.leg2ArrivalTime, data.leg2ArrivalTimeTz)}
                            </td>
                            <td className='text-center'>
                                {renderDate(data.leg2ArrivalTimeBackup, data.leg2ArrivalTimeBackupTz)}
                            </td>
                            <td className='text-center'>
                                {renderDate(data.leg2ArrivalTimeActual, data.leg2ArrivalTimeActualTz)}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>Recovered from Airline Date/Time</td>
                            <td></td>
                            <td></td>
                            <td className='text-center'>
                                {renderDate(data.recoveredFromAirlineActual, data.recoveredFromAirlineActualTz)}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>Kidney Arrival Date/Time</td>
                            <td className='text-center'>
                                {renderDate(data.kidneyArrivalDateTime, data.kidneyArrivalDateTimeTz)}
                            </td>
                            <td className='text-center'>
                                {renderDate(data.kidneyArrivalDateTimeBackup, data.kidneyArrivalDateTimeTz)}
                            </td>
                            <td className='text-center'>
                                {renderDate(data.kidneyArrivalDateTimeActual, data.kidneyArrivalDateTimeTz)}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>Delivery Location</td>
                            <td></td>
                            <td></td>
                            <td className='text-center'>
                                {data.deliveryLocation}
                            </td>
                        </tr>
                        <tr>
                            <td className='text-right' style={{ fontWeight: 700 }}>Signed For</td>
                            <td></td>
                            <td></td>
                            <td className='text-center'>
                                {data.deliveredTo}
                            </td>
                        </tr>
                    </TableBodyWrapper>
                </TableWrapper>
            </div>
        </>
    );
}

export default LogisticsViewContent;